/**
 * After AJAX-injecting Yotpo widget markup, scripts do not run and the widget
 * runtime may not bind to new nodes. See Yotpo SPA docs: call initWidgets when
 * new widget containers are added to the DOM.
 *
 * @see https://support.yotpo.com/docs/implementing-yotpo-review-widgets-with-single-page-application-spa
 */
export default function reinitYotpoWidgets() {
  if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
    window.yotpoWidgetsContainer.initWidgets();
    return;
  }
  if (typeof window.yotpo?.initWidgets === 'function') {
    window.yotpo.initWidgets();
  }
}
